import event from '../../event/event';

export default event('/events/auth/force/authorization');
